export default __webpack_public_path__ + "static/media/star.2aaa7c00.svg";